<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Supplies Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label>Supplies Name</label>
                <input type="text" class="form-control" v-model="supplies.name" id="patientName" aria-describedby="action">
            </div>
            <div class="form-group col-2">
                <label>Is Active?</label>
                <div class="input-group-text col-lg-6">
                    <input type="checkbox" v-model="supplies.isActive" id="dtp-supplies-is-active">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="module">Remarks</label>
                <textarea class="form-control" id="desc-textarea" v-model="supplies.remarks" rows="2"></textarea>
            </div>
        </div>
        <br /><br />
        <app-datatable :type="'input'" :newData="suppliesDetail" :elements="dtElementsDetail" :collections="supplies.detail"></app-datatable>
        <br /><br />
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { Supplies, SuppliesDetail } from '../../models/supplies'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
    },
    data() {
        return {
            supplies: {
                ...Supplies,
                detail: [],
            },
            suppliesDetail: SuppliesDetail,
            dtElementsDetail: [
            {
                title: 'Date',
                column: 'date',
                type: 'date',
                width: 4,
            },
            {
                title: 'Supplier',
                column: 'supplierName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'supplier-list',
                    title: 'Supplier List',
                    type: 'table',
                    apiUrl: 'supplier-list',
                    filter: ['name'],
                    fields: [
                        {
                            placeholder: 'Supplier Name',
                            width: 5,
                            column: 'supplierName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'Supplier Name',
                            column: 'name'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'supplierId'
                        },
                        {
                            from: 'name',
                            to: 'supplierName'
                        },
                    ]
                },
                disable: true,
            },
            {
                title: 'UOM',
                column: 'uomName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'uom-list',
                    title: 'UOM List',
                    type: 'table',
                    apiUrl: 'uom-list',
                    filter: ['name'],
                    fields: [
                        {
                            placeholder: 'UOM Name',
                            width: 5,
                            column: 'uomName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'UOM Name',
                            column: 'name'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'uomId'
                        },
                        {
                            from: 'name',
                            to: 'uomName'
                        },
                    ]
                },
                disable: true,
            },
            {
                title: 'Qty',
                column: 'qty',
                type: 'number',
                width: 4,
            },
            {
                title: 'Price',
                column: 'price',
                type: 'number',
                width: 4,
            },
            {
                title: 'Remarks',
                column: 'remarks',
                type: 'text',
                width: 4,
            },
          ],
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const mrApi = api('supplies/detail')

            const medicalRecordResult = await mrApi.getWithParams(this.$route.query.id)
            this.supplies = medicalRecordResult
        }
    },
    methods: {
        async save() {
            const mrApi = api('supplies')
            if(this.$route.query.id !== undefined) {
                await mrApi.update(this.supplies, this.$route.query.id)
            } else {
                await mrApi.create(this.supplies)
            }
            this.$router.push({ name: 'supplies' })
        },
        cancel() {
            this.$router.push({ name: 'supplies' })
        },
        finishLookup(data) {
            const currentMedical = this.supplies
            this.supplies = {
                ...currentMedical,
                ...data
            }
        },
        selectChange(data) {
            const currentMedical = this.supplies
            this.supplies = {
                ...currentMedical,
                ...data
            }
        }
    }
}
</script>